import React, { createContext, useEffect, useRef, useState } from 'react';
import './index.less';
import Header from './Header';
import Banner from './Banner';
import Background from './Background';
import PlatformValues from './PlatformValues';
import KeyAdvantages from './KeyAdvantages';
import IndustryCases from './IndustryCases';
import LoginModal from './LoginModal';
import BlueStart from './BlueStart';
import Footer from './Footer';
import { getAccountId, refreshPassToken } from 'utils/login';
import { useDispatch, useSelector } from 'react-redux';
import { getLoginInfoThunk } from 'redux/common/actions';
import { useQuery } from 'hooks/url';
import { Route, Switch, useHistory, useLocation } from 'react-router';
import { history } from 'index';
import Store from 'redux/type';
import { LazyShow } from 'component/LazyShow';
import { Feature } from './MarkdownPage/Feature';
import { useTransition, animated, config as springConfig } from 'react-spring';
import MarkdownPage from './MarkdownPage';
import { RouterPath } from 'constants/constants';

export const LoginModalCtx = createContext({
    openLoginModal: () => {},
    enterSystem: () => {},
    loginModalShow: false,
});

export default function Home() {
    useEffect(() => {
        document.title = '磁力万象 - 商业化数据营销增长引擎';
    }, []);

    const dispatch = useDispatch();
    useEffect(() => {
        init();
    }, []);

    async function init() {
        await refreshPassToken();
        dispatch(getLoginInfoThunk());
    }

    const [loginModalShow, setLoginModalShow] = useState(false);
    function openLoginModal() {
        setLoginModalShow(true);
    }
    const userInfo = useSelector((state: Store) => state.common.loginInfo.user);
    function enterSystem() {
        if (userInfo) {
            const accountInfo = getAccountId();
            history.push(accountInfo ? RouterPath.FRONT_PAGE : '/account-compass');
        } else {
            openLoginModal();
        }
    }

    const history = useHistory();
    const showLogin = !!useQuery('showLogin');
    useEffect(() => {
        if (showLogin) {
            openLoginModal();
            const searchParser = new URLSearchParams(window.location.search);
            searchParser.delete('showLogin');
            const resultUrl = window.location.pathname + '?' + searchParser.toString();
            history.replace(resultUrl);
        }
    }, []);

    // 记录是否第一次进入页面
    const isFirst = useRef(true);
    const location = useLocation();
    const [currentLocation, setCurrentLocation] = useState(location);
    const [direction, setDirection] = useState<'left' | 'right'>('left');
    const isHome = location.pathname === '/';

    useEffect(() => {
        setCurrentLocation(location);
        if (location.pathname.length > currentLocation.pathname.length) {
            setDirection('left');
        } else {
            setDirection('right');
        }
    }, [location]);
    const transitions = useTransition(
        currentLocation,
        (location) => location.pathname,
        isFirst.current
            ? {}
            : {
                  from: {
                      position: 'absolute',
                      width: '100%',
                  },
                  enter() {
                      return {
                          position: 'relative',
                          width: '100%',
                      };
                  },
                  leave: {
                      position: 'absolute',
                      width: '100%',
                  },
                  config: {
                      //   duration: 1,
                  },
                  immediate: true,
              },
    );
    useEffect(() => {
        isFirst.current = false;
    }, []);
    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [location.pathname]);

    const MainComp = () => (
        <>
            <LazyShow placeholderHeight={870}>
                <Banner isHome={isHome} />
            </LazyShow>
            <LazyShow placeholderHeight={800}>
                <PlatformValues />
            </LazyShow>
            <LazyShow placeholderHeight={890}>
                <KeyAdvantages />
            </LazyShow>
            <LazyShow placeholderHeight={1100}>
                <IndustryCases />
            </LazyShow>
        </>
    );

    const FeaturePage = () => (
        <MarkdownPage pageClassName="feature" menuShow={location.pathname === '/feature'}>
            <Feature />
        </MarkdownPage>
    );

    return (
        <LoginModalCtx.Provider value={{ loginModalShow, openLoginModal, enterSystem }}>
            <div
                className={`home ${!isHome ? 'not-route-home' : ''}`}
                style={{
                    backgroundColor: isHome ? '#212224' : '#ffffff',
                }}
            >
                <Header />
                <main className="content container">
                    {transitions.map(({ item, props, key }) => (
                        <animated.div key={key} id={`home-route-${item.pathname}`} style={props}>
                            <Switch location={item}>
                                <Route path="/" exact render={MainComp} />
                                <Route path="/feature" exact render={FeaturePage} />
                            </Switch>
                        </animated.div>
                    ))}
                </main>
                <LoginModal visible={loginModalShow} onCancel={() => setLoginModalShow(false)} />
                {isHome && (
                    <LazyShow placeholderHeight={380}>
                        <BlueStart />
                    </LazyShow>
                )}

                <Footer />
            </div>
        </LoginModalCtx.Provider>
    );
}
